<template>
  <div class="popup" v-if="rescueList.length">
    <el-row class="popup-top">
      <el-col :span="12" class="tip"><img :src="imgWaring" alt="" />摔车事故监控</el-col>
      <el-col :span="12" class="close-btn"><i class="el-icon-circle-close" @click="deleteTap"></i></el-col>
    </el-row>
    <div class="popup-box">
      <div class="text">事故类型：摔车事故</div>
      <div class="text">车主手机号：{{ newRescue.phone || '--' }}</div>
      <div class="text">车架号：{{ newRescue.vin || '--' }}</div>
      <div class="text">定位：{{ newRescue.address || '--' }}</div>
      <div class="text">时间：{{ newRescue.eventDate || '--' }}</div>
      <div class="text">当日播报次数：{{ newRescue.currentDayCount || 0 }}</div>
      <div class="text">历史播报次数：{{ newRescue.historyCount || 0 }}</div>
      <div class="btn-footer"><el-button type="primary" size="small" @click="toRescue">立即查看</el-button></div>
    </div>
  </div>
</template>

<script>
import imgWaring from '@/assets/images/waring.png';
export default {
  data() {
    return {
      imgWaring,
    };
  },
  computed: {
    rescueList() {
      const { rescue } = this.$store.state;
      return rescue.rescueList;
    },
    newRescue() {
      let rescueList = this.rescueList;
      if (!rescueList.length) {
        return {};
      }
      let len = rescueList.length;
      return rescueList[len - 1];
    },
  },
  methods: {
    deleteTap() {
      const { rescue } = this.$store.state;
      let rescueList = rescue.rescueList;
      if (!rescueList.length) return;
      rescueList.pop();
      this.$store.dispatch('rescue/fetch_rescueList', rescueList);
    },
    toRescue() {
      this.$store.dispatch('rescue/fetch_rescueList', []);
      this.$router.push({ name: 'console.vehicleMonitor.accident' });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.popup {
  position: fixed;
  z-index: 200;
  bottom: 0;
  right: 0;
  width: 100%;
  width: 300px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px 1px rgba(171, 171, 171, 0.5);
  .popup-top {
    background: #409eff;
    height: 36px;
    padding: 0 15px;
    box-sizing: border-box;
    .tip {
      align-items: center;
      color: #fff;
      display: flex;
      justify-content: start;
      font-size: 14px;
      height: 100%;
      img {
        height: 20px;
        width: 20px;
        margin-right: 5px;
      }
    }
    .close-btn {
      justify-content: end;
      display: flex;
      align-items: center;
      height: 100%;
      .el-icon-circle-close {
        color: #ffffff;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  .popup-box {
    padding: 20px 20px 15px;
    .text {
      color: #666;
      font-size: 12px;
      line-height: 20px;
    }
    .btn-footer {
      margin-top: 15px;
      text-align: right;
    }
  }
}
</style>
